import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import RequestsGDC from './Requests.GDC';

const Requests = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <RequestsGDC {...props} />;
    case Portal.Efigas:
      return <RequestsGDC {...props} />;
    default:
      return <></>;
  }
};

export default Requests;
